import Nav from "./nav"
import Homepage from "./Homepage"
function Header(){
    return(
        <>
    {/* <!--------------------------qiimayaasha dahabka---------------> */}
    <header className="header_sare">
        <nav className="nav_head">
            <Nav />
            <div className="haye">
                <Homepage />
            </div>
            {/* <!-- <div className="sawir_wave">
                <img src="images/wave.svg" alt="ss">
            </div> --> */}
        </nav>
    </header>
    </>
    )
}


export default Header